import React from 'react';
import { BaseText } from './BaseText';
import { defineFontSettings } from './fontSettings';

export const Body3 = (props) => {
  const { children } = props;
  const fontSettings = defineFontSettings(
    { fontSize: '12px', lineHeight: '18px' },
    { fontSize: '16px', lineHeight: '24px' }
  );
  return (
    <BaseText fontSettings={fontSettings} {...props}>
      {children}
    </BaseText>
  );
};
